import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const MainPageComponent = React.lazy(() => import("../Components/RootComponents/MainPageComponent"));
const MainPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <MainPageComponent />
      </Suspense>
    </Fragment>
  );
};

export default MainPage;
